import { useMemo } from 'react';
import { ItemProps, ItemPureProps } from './types';

const getVariantByState = (isSelected: boolean, variant: ItemPureProps['variant']) => (!isSelected && variant === 'primary' ? 'secondary' : variant);

/**
 * For props passed to Item component returns memoized (for context provider) props with proper defaults and calculations
 */
export const useItemProps = ({
  size = 'sm',
  isHoverable = true,
  borderRadius = 'sm',
  isSelected = false,
  showCheckIconWhenSelected = false,
  selectionVariant = 'solid',
  variant = 'primary',
  isFocused = false,
  isStriped = false,
  ...rest
}: ItemProps) => ({
  props: useMemo<ItemPureProps>(
    () => ({
      size,
      isHoverable,
      borderRadius,
      isSelected,
      showCheckIconWhenSelected,
      selectionVariant,
      variant: getVariantByState(isSelected, variant),
      isFocused,
      isStriped,
    }),
    [borderRadius, isFocused, isHoverable, isSelected, isStriped, selectionVariant, showCheckIconWhenSelected, size, variant]
  ),
  rest,
});
